/**
 * Resolve the signed-in user's stable id for request ownership (CT-4202 capture
 * + CT-4203 "My requests" filter — both MUST use this so a submitted request and
 * the owner filter agree).
 *
 * The platform's stable identity is `user_uuid` (persisted in localStorage by
 * @aimsos/auth after the /v1/token exchange — the same id the agents domain
 * stamps as created_by). Fall back to the Auth0 subject `sub`, then email, then
 * a dev-only placeholder. Auth0 profiles do NOT expose `user.id`, so never read
 * it. Mock-first until the backend assigns ownership server-side (CT-3904).
 *
 * @param {{ sub?: string, email?: string } | null | undefined} user - useAuth().user
 * @returns {string}
 */
export const resolveRequesterId = (user) =>
  (typeof window !== 'undefined' && window.localStorage.getItem('user_uuid')) ||
  user?.sub ||
  user?.email ||
  'current-user';
